@if (headerName) {
    <span class="ag-header-cell-label">{{ headerName | translate }}</span>
}
<button title="{{ 'grid.clearFilters' | translate }}" class="button button-renderer small" (click)="clearFilters()">
    <i class="far fa-filter-circle-xmark"></i>
</button>
